import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const caixabankTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.caixabank,
  logoUrl: "https://cdn.nemuru.com/assets/logos/caixabank-borrower.svg",
  palette: {
    primary: {
      main: "#007EAE",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1A1A1A",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#efefef",
      contrastText: "#1A1A1A",
      accent: "#007EAE",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#1A1A1A",
      primary: "#505050",
      secondary: "#6f6f6f",
    },
    status: {
      sent: "#525252",
      denied: "#e52725",
    },
    info: {
      main: "#007EAE",
      contrastText: "#ffffff",
      light: "#d6dbdf",
    },
    warning: {
      main: "#f4c53d",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#007EAE",
      contrastText: "#ffffff",
      light: "rgba(0,125,174,0.15)",
    },
  },
  assetPackDefsId: assetPackIds.FILLED,
  background: "#f0f0f0",
  customBorderRadius: {
    button: 2,
    paper: 0,
  },
  typography: {
    fontFamily: "Arial, Helvetica, sans-serif",
  },
};
